// extracted by mini-css-extract-plugin
export default {"container":"AlertDismissable_container__pR0tV","heading":"AlertDismissable_heading__PUcfj","link":"AlertDismissable_link__xVaaB"};